// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__K3Zif","navigate_table":"styles_navigate_table__l38+j","search_block":"styles_search_block__aeawM"};